import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getOrderSummaryList = async (payload) => {
  try {
    return await postRequest(urls.ORDER_SUMMARY_LIST, payload);
  } catch (err) {
    return err;
  }
};
